import type { CategoryId, ItemId } from './ids';
import type { Formula, Item } from './item';

/**
 * Items a formula depends on within a scope (a scenario's items, or all project items for
 * conservative validation). Category references expand to every flow/formula in that category,
 * which makes "10 % of my own category" a cycle, as it should be. Totals only cover scheduled
 * flows, so they never create edges to formulas.
 */
export function formulaDependencies(formula: Formula, scope: readonly Item[]): ItemId[] {
  const deps: ItemId[] = [];
  const byCategory = new Map<CategoryId, ItemId[]>();
  for (const item of scope) {
    if ((item.type === 'flow' || item.type === 'formula') && item.category !== undefined) {
      const list = byCategory.get(item.category) ?? [];
      list.push(item.id);
      byCategory.set(item.category, list);
    }
  }
  for (const source of formula.spec.sources) {
    const ref = source.ref;
    if (ref.type === 'item') deps.push(ref.id);
    else if (ref.type === 'category') deps.push(...(byCategory.get(ref.id) ?? []));
  }
  return deps;
}
